import { render, staticRenderFns } from "./StackCardList.vue?vue&type=template&id=2af15abc&scoped=true&"
import script from "./StackCardList.vue?vue&type=script&lang=js&"
export * from "./StackCardList.vue?vue&type=script&lang=js&"
import style0 from "./StackCardList.vue?vue&type=style&index=0&id=2af15abc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af15abc",
  null
  
)

export default component.exports